import Loadable from '../../components/loadable';

const ContactAttendancesReport = Loadable({
  loader: () => import('../../pages/reports/contact_attendances_report/contact_attendances_report'),
});

angular.module('gym').value('ContactAttendancesReport', ContactAttendancesReport);

const ContactAttendancesReportFiltersModal = Loadable({
  loader: () =>
    import(
      '../../pages/reports/contact_attendances_report/contact_attendances_report_filters_modal'
    ),
  type: 'modal',
});

angular
  .module('gym')
  .value('ContactAttendancesReportFiltersModal', ContactAttendancesReportFiltersModal);
